import React from 'react';
import { ModalFooter, Button, HStack } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';

interface Props {
  onClose: () => void;
  onSubmit: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
}

const PackageEditModalFooter: React.FC<Props> = ({
  onSubmit,
  onClose,
  isDisabled,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <ModalFooter as={HStack} justify="flex-end">
      <Button variant="grayedGhost" onClick={onClose}>
        {t('CANCEL')}
      </Button>

      <Button onClick={onSubmit} isDisabled={isDisabled} isLoading={isLoading}>
        {t('SAVE-AND-CLOSE')}
      </Button>
    </ModalFooter>
  );
};

export default PackageEditModalFooter;
